import { render, staticRenderFns } from "./popup-intro.vue?vue&type=template&id=b03cdcf6&scoped=true&"
import script from "./popup-intro.vue?vue&type=script&lang=js&"
export * from "./popup-intro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03cdcf6",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage, CText: require('@chakra-ui/vue').CText, CFlex: require('@chakra-ui/vue').CFlex, CButton: require('@chakra-ui/vue').CButton})
